<template>
  <div class="row sorting  justify-content-end me-0" :class="{ 'mt-3': !goal.parent_module_goal_id }"
       :data-id="goal.id"
       :data-parent-id="goal.parent_id"
       :data-level="goal.level_number">

    <div class="holiday_user_data"
         :style="{
             cursor: 'pointer',
             width: `${goal.width}%`,
             borderRadius: '3px',
             marginBottom: '8px',
             backgroundColor: goal.parent_id ? '' : '#e4e4e4',
             padding: '5px'
           }">

      <div :style="{ display: 'inline-block', width: `80%`, float: 'left' }">
<!--                <span v-html="goal.id"></span><br>-->
<!--                <span v-html="goal.parent_id"></span><br>-->
<!--                <span v-html="goal.level_number"></span><br>-->
        <span v-html="goal.name"></span>
      </div>

      <div class="buttons">
        <span class="editGoalButton" @click="goalEdit(goal.id)">
              <i class="os-icon os-icon-ui-49"></i>
        </span>
        <span class="deleteGoalButton" @click="goalDelete(goal.id)">
              <i class="os-icon os-icon-ui-15"></i>
        </span>
        <span class="btn btn-outline-primary createGoalButton" @click="goalCreate(goal.id)">
              Unterziel erstellen
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  goal: {
    type: Object,
    required: true,
  },
  parentGoalId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits([
  'update:modelValue',
  'update:goalId',
  'update:parentGoalId',
  'update:showDeleteModal',
]);

const goalCreate = (parentId) => {
  emit('update:modelValue', true);
  emit('update:parentGoalId', parentId);
};

const goalEdit = (goalId) => {
  emit('update:modelValue', true);
  emit('update:goalId', goalId);
};

const goalDelete = (goalId) => {
  emit('update:showDeleteModal', true);
  emit('update:goalId', goalId);
};

</script>

<style scoped>
.buttons {
  width: 230px;
  text-align: right;
  float: right
}

.createGoalButton {
  float: right;
  margin-top: 4px;
  background-color: white
}

.editGoalButton {
  color: var(--blue);
  display: inline-block;
  margin-right: 13px;
  width: 30px;
  float: left;
  font-size: 26px;
}

.deleteGoalButton {
  color: red;
  display: inline-block;
  margin-right: 6px;
  width: 30px;
  float: left;
  font-size: 26px;
}

/* Add any specific styles here if needed */
</style>
